/* 検索項目つきテキストボックス、項目選択のダイアログ */
import React, { memo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { KeyValue } from '../types/KeyValue';

interface Props {
  is_confirm: boolean;
  details: Array<KeyValue>;
  show: boolean;
  title: string;
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  ClickCallBackYes: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  ClickCallBackNo: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  field_column_name: string;
}

const TextWithSearchDialog: React.FC<Props> = ({
  is_confirm,
  details,
  show,
  title,
  handleChange,
  ClickCallBackYes,
  ClickCallBackNo,
  field_column_name,
}) => {
  // 検索条件管理用
  const [filter_query, setFilterQuery] = useState('');
  // 検索後のdetails
  const [filtered_details, setFilteredDetails] = useState<Array<KeyValue> | []>([]);
  // 検索結果の表示用
  const filtered_details_display = filter_query.length > 0 ? filtered_details : details;
  const handleChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterQuery(event.target.value);
    const filtered_details_result = details.filter(
      (detail) => detail.value.indexOf(event.target.value) === 0
    );
    setFilteredDetails(filtered_details_result);
  };
  const handleClickYes = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    ClickCallBackYes(event);
    setFilterQuery('');
  };
  const handleClickNo = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    ClickCallBackNo(event);
    setFilterQuery('');
  };
  return (
    <Modal
      size="lg"
      centered
      show={show}
      onHide={() => {
        return;
      }}
    >
      <Modal.Header>
        <Modal.Title className="dialog-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dialog-body">
        <div className="text-with-search-dialog">
          <input
            className="form-select-label form-control"
            placeholder={'検索条件を入力'}
            value={filter_query}
            onChange={handleChangeText}
          />
          <div className="form-select-body">
            <select
              className="form-select"
              onChange={handleChange}
              size={10}
              name={field_column_name}
            >
              {filtered_details_display.map((detail, index) => {
                return (
                  <option key={index} value={detail.value}>
                    {detail.value}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {is_confirm ? (
          <Button variant="main-color">確認</Button>
        ) : (
          <>
            <Button variant="main-color" onClick={handleClickYes}>
              OK
            </Button>
            <Button style={{ width: '6rem' }} variant="main-color" onClick={handleClickNo}>
              キャンセル
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default memo(TextWithSearchDialog);
